import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

 transform(value: string, start: number, end: number): string {
    if (!value) return '';
    return `${value.slice(0, start)}...${value.slice(-end)}`;
  }

}
